import { useState } from "react";

import { APP_MODE } from "@constants/shared";
import {
  AppMode,
  AppModeContextType,
  AppModeProviderProps,
} from "@models/components/kiosk.model";

import AppModeContext from "./AppModeContext";

export const AppModeProvider = ({
  children,
  initialMode = "web",
}: AppModeProviderProps) => {
  const [mode, setMode] = useState<AppMode>(initialMode);

  const value: AppModeContextType = {
    isKioskMode: mode === APP_MODE.KIOSK,
    isWebMode: mode === APP_MODE.WEB,
    mode,
    setMode,
  };

  return (
    <AppModeContext.Provider value={value}>{children}</AppModeContext.Provider>
  );
};
